module.exports = __webpack_public_path__ + "static/media/map02.47b7c60b.gif";